import SingleIcon from 'icons/single-filled.svg';
import AlbumIcon from 'icons/album-filled.svg';
import VideoIcon from 'icons/video-filled.svg';
import PodcastIcon from 'icons/podcast-filled.svg';
import ArtistIcon from 'icons/artist-filled.svg';
import { ITab } from 'components/Library/Columns/tabledatatype';
export const LIBRARY_TAGS: { [key: string]: ITab } = {
  single: {
    label: 'Single',
    type: 'single',
    icon: SingleIcon
  },
  song: {
    label: 'Song',
    type: 'single',
    icon: SingleIcon
  },
  episode: {
    label: 'Episode',
    type: 'episode',
    icon: PodcastIcon
  },
  single_episode: {
    label: 'Single Episode',
    type: 'episode',
    icon: PodcastIcon
  },
  video: {
    label: 'Video',
    type: 'video',
    icon: VideoIcon
  },
  artist: {
    label: 'Artist',
    type: 'artist',
    icon: ArtistIcon
  },
  album: {
    label: 'Album',
    type: 'album',
    icon: AlbumIcon
  },
  show: {
    label: 'Show',
    type: 'show',
    icon: PodcastIcon
  }
};
